export const PermissionsGqlFields = `
    id
    name
    displayName
`;
